import script from "./QueryPublicWorksView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryPublicWorksView.vue?vue&type=script&setup=true&lang=js"

import "./QueryPublicWorksView.vue?vue&type=style&index=0&id=20ce68aa&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ce68aa"]])

export default __exports__